import React from 'react';
import { bool, shape, string } from 'prop-types';

const WarningAmber = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z" fill="currentColor" />
  </svg>
);

WarningAmber.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default WarningAmber;
